import { Component } from '@angular/core';
import { InstitucionPage } from 'src/app/models/entidad-page.interface';
import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-administrador-instituciones',
  templateUrl: './administrador-instituciones.component.html',
  styleUrls: ['./administrador-instituciones.component.scss']
})
export class AdministradorInstitucionesComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  institucionesPageInformacion: HttpPaginacion<InstitucionPage> | undefined;
  institucionPage: InstitucionPage[] = [];
  constructor(private adiministradorService: AdministradorService) {
    this.obtenerInformacion(1);
  }

  obtenerInformacion(page: number): void {
    this.adiministradorService.instituciones(page)
      .subscribe({
        next: (resp) => {
          this.institucionesPageInformacion = resp;
          this.institucionPage = resp.data;

          this.first = (resp.current_page - 1) * resp.per_page;
          this.rows = resp.per_page;
          this.totalRecords = resp.total;
        },
        error: (err) => console.log(err)
      })
  }

  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);

  }
  exportExcel(): void {
    const url = environment.urlbase + environment.xlsxs.datosGeneralesInstituciones;
    window.open(url, "_blank");
  }
}
